<template lang="pug">
  button.btn.btn-danger(type="button" @click="modalConf = true" title="名刺人物の削除" data-testid="-btn-delete-person"): i.fa.fa-trash

    //------------------------------------------------------------
    //- modals
    //------------------------------------------------------------
    portal(to="modal")
      //- 確認
      app-modal(v-model="modalConf" type="danger")
        template(slot="title") 確認
        h4 選択した名刺の人物情報を削除します。よろしいですか？
        p.text-danger ※ 選択した人物に登録されているすべてのデータが削除されます。
        p.text-danger ※ 修正サービス依頼中の名刺は削除できません。
        .panel.panel-danger
          .panel-body
            ul
              li 人物情報
              li 名刺情報
              li 名刺交換者
              li ソーシャルサイト
              li 共有メモ
              li 兼務情報
              li 添付ファイル
              li 検索キーワード
              li 個人メモ
        template(slot="footer", slot-scope="{close}")
          button.btn.btn-danger(type="submit" @click="submit") 削除
          button.btn.btn-default(type="button" @click="close") キャンセル
</template>

<script>
import AppModal from '@/components/templates/AppModal'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const ManagePersonRepository = RepositoryFactory.get('manageperson')

export default {
  name: 'FuncDelPerson',
  components: { AppModal },
  props: {
    sidPerson: { type: [Number, String], required: false, default: '' }
  },
  data: function () {
    return {
      modalConf: false
    }
  },
  methods: {
    submit () {
      if (!this.isMgmt || !this.sidPerson) {
        this.showToast('名刺人物情報を削除する権限がありません。', { type: 'danger' }) // system error
        this.modalConf = false
        return
      }

      const vm = this
      ManagePersonRepository.delete(this.sidPerson)
        .then(function (response) {
          if (vm.isApiSuccess(response)) {
            vm.$emit('success')
            vm.showToast('名刺人物情報を削除しました。', { type: 'success' })
            vm.modalConf = false
            // 一覧更新
            vm.$store.dispatch('reloadBcardList')
          }
        })
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || '名刺人物情報を削除できませんでした。'
          vm.showToast(message, { type: 'danger' })
        })
        // .finally(function () {
        //   vm.modalDelete.isExec = false
        // })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/organisms/functions/FuncDelPerson.vue